import { render, staticRenderFns } from "./SelectTaskTipe.vue?vue&type=template&id=62212e4a&"
import script from "./SelectTaskTipe.vue?vue&type=script&lang=js&"
export * from "./SelectTaskTipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports